import WebStore from '../views/webStore/WebStore';
import VipPage from '../views/webStore/VipPage';
export default [
  {
    path: '/',
    name: '',
    component: WebStore
  },
  {
    path: '/vip_score',
    name: 'vipScore',
    component: VipPage
  }
];
